module.exports = {
    standardProviderId: 'password',
    federatedProviderId: 'federated',
};


/** WEBPACK FOOTER **
 ** ./src/constants/cls-provider-type.js
 **/